// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1uf-0","footer":"ModalError_footer__1gXUg"};